export default __webpack_public_path__ + "assets/media/incorrect-answer.7fe1a272.mp3";